import { inject } from 'vue';
import { apiGatewayEndpoints } from '~/services/arcane-api-gateway/api-gateway-endpoints';
import { mapTableEntriesToEntityEntries } from '~/utils/glossary';

export default () => {
  const GLOSSARY_COMPONENT = {
    list: 'GlossariesList',
    overview: 'GlossaryOverview',
  };

  const arcaneApiGateway = inject('arcaneApiGateway');

  const getSupportedLanguages = async () => {
    const {
      data: { supportedLanguages },
    } = await arcaneApiGateway.get(apiGatewayEndpoints.glossary.supportedLanguages);
    return supportedLanguages;
  };

  const getArcaneGlossaries = async () => {
    const response = await arcaneApiGateway.get(apiGatewayEndpoints.glossary.arcaneGlossaries);
    return response.data;
  };

  const saveGlossary = async (headers, rows, glossary, publicValue, name) => {
    let response;
    const entries = mapTableEntriesToEntityEntries(headers, rows);
    const newGlossary = {
      entries,
      isPublic: publicValue === 1,
      title: name,
    };

    try {
      if (glossary.id) {
        // update case
        response = await arcaneApiGateway.put(
          apiGatewayEndpoints.glossary.updateArcaneGlossary(glossary.id),
          newGlossary,
        );
      } else {
        // create case
        response = await arcaneApiGateway.post(apiGatewayEndpoints.glossary.createArcaneGlossary, newGlossary);
      }
      return response.data;
    } catch (err) {
      console.log('Error in saving glossary', err);
    }
  };

  const removeGlossary = async (glossaryId) => {
    try {
      await arcaneApiGateway.delete(apiGatewayEndpoints.glossary.updateArcaneGlossary(glossaryId));
    } catch (err) {
      console.log('Error in removing glossary', err);
    }
  };

  const getAvailableGlossaries = async (targetLang, sourceLang = 'EN') => {
    const { data } = await arcaneApiGateway.get(
      apiGatewayEndpoints.glossary.availableGlossariesByTargetAndSource(sourceLang, targetLang),
    );
    return data;
  };

  return {
    getArcaneGlossaries,
    getAvailableGlossaries,
    getSupportedLanguages,
    GLOSSARY_COMPONENT,
    removeGlossary,
    saveGlossary,
  };
};
